<template>
  <div class="search-item-bottom-links">
    <TextLink :href="backToGiftCardEditUrl">
      作成中のギフトカードへ戻る
    </TextLink>
    <TextLinkToTop />
  </div>
</template>

<script setup>
import TextLinkToTop from '~/src/js/customer/components/organism/bulk_personal_orders/TextLinkToTop.vue'
import TextLink from '~/src/js/customer/components/atoms/text_links/TextLink.vue'

defineProps({
  backToGiftCardEditUrl: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.search-item-bottom-links {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  &__submit {
    display: none;
  }
}
</style>
